module.exports = __webpack_public_path__ + "img/hr-dirt-5.801386b8.png";